module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/symbol.js
// module id = 46
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/babel-runtime/core-js/symbol.js